<template>
    <transition name="slide">
        <aside v-if="visible" class="intro-sidebar promo-sidebar">
            <button class="close-button" @click="$emit('close')" :aria-label="$t('introSidebar.close')">
                <i class="fas fa-times"></i>
            </button>

            <div class="promo-content">
                <h2 class="promo-title">
                    {{ $t('introSidebar.promoTitle') }}
                </h2>

                <img class="promo-image" src="../../assets/images/content/promo_sidebar.svg"
                    :alt="$t('introSidebar.promoImageAlt')" />

                <p class="promo-text" v-html="$t('introSidebar.promoText')">
                </p>

                <ul class="promo-features">
                    <li>
                        <i class="fas fa-rocket"></i>
                        {{ $t('introSidebar.features.autoRollout') }}
                    </li>
                    <li>
                        <i class="fas fa-chart-bar"></i>
                        {{ $t('introSidebar.features.analytics') }}
                    </li>
                    <li>
                        <i class="fas fa-palette"></i>
                        {{ $t('introSidebar.features.templateCustomization') }}
                    </li>
                    <li>
                        <i class="fas fa-building"></i>
                        {{ $t('introSidebar.features.corporateIntegrations') }}
                    </li>
                </ul>

                <div class="promo-buttons">
                    <a class="btn primary" href="https://gsignature.com/pricing" target="_blank"
                        rel="noopener noreferrer">
                        {{ $t('introSidebar.buttons.viewPricing') }}
                    </a>
                    <a class="btn secondary" href="https://gsignature.com/sign-up" target="_blank"
                        rel="noopener noreferrer">
                        {{ $t('introSidebar.buttons.trial') }}
                    </a>
                </div>
            </div>
        </aside>
    </transition>
</template>

<script>
export default {
    name: "IntroSidebar",
    props: {
        visible: { type: Boolean, required: true },
    },
};
</script>

<style scoped>
.intro-sidebar {
    position: fixed;
    top: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
    width: 350px;
    max-width: 100%;
    z-index: 1000;
    overflow-y: auto;
    margin-left: 0.5rem;
}

.promo-sidebar {
    background: #f7ffe6;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

.promo-content {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    gap: 1rem;
}

.promo-sidebar .close-button {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    cursor: pointer;
    color: #333;
}

.promo-title {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.3;
    margin: 0;
    color: #111;
}

.promo-image {
    width: 100%;
    margin: 1rem 0;
    object-fit: contain;
}

.promo-text {
    font-size: 1rem;
    line-height: 1.4;
    color: #333;
    margin: 0.5rem 0 1rem;
}

.promo-features {
    list-style: none;
    padding: 0;
    margin: 0;
}

.promo-features li {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    color: #333;
    margin-bottom: 0.75rem;
    font-weight: bold;
}

.promo-features li i {
    margin-right: 0.5rem;
    width: 1rem;
    text-align: center;
}

.promo-buttons {
    display: flex;
    gap: 0.5rem;
    margin-top: auto;
}

.btn {
    flex: 1;
    padding: 0.6rem 0.75rem;
    border-radius: 4px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: transform 0.2s;
    text-align: center;
}

.btn:hover {
    transform: scale(1.02);
}

.btn.primary {
    background: #ff6a00;
    color: #fff;
    border: none;
}

.btn.secondary {
    background: transparent;
    color: #333;
    border: 1px solid #333;
}

.slide-enter-from,
.slide-leave-to {
    transform: translateX(100%);
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 0.6s ease;
}

.slide-enter-to,
.slide-leave-from {
    transform: translateX(0);
}
</style>
